define([
	"domReady",
	"wcs.context",
	], function(domReady, context) {

	domReady(function() {

		// Log visitor user type and data
		try {
			var loggedIn 			= context.getUserType() == 'G'? false:true;
			var loyaltyOptInStatus 	= context.getLoyaltyOptIn() == '0'? false:true;
			var memberID			= context.getUserId();
			var userObj = {
						'memberID' : loggedIn ? memberID:null,
						'loggedIn' : loggedIn,
						'loyaltyMember' : loggedIn ? loyaltyOptInStatus:false
					};
			var clvVal = context.getCookie('customer_clv_data')!== undefined ? context.getCookie('customer_clv_data'):null;
			var sfAccount = context.getCookie('USER_DL')!== undefined ? context.getCookie('USER_DL'):null;

			window.dataLayer = window.dataLayer || {};
			window.dataLayer.push({
				'user' : userObj
			});
			var userEventObj = {'loggedIn': loggedIn, 'loyaltyMember' : loggedIn ? loyaltyOptInStatus:false};
			if(loggedIn){
				if(clvVal !== undefined && clvVal != null){
					try{
						var clvJSON = JSON.parse(clvVal);
						for (var key in clvJSON){
							userEventObj[key] = clvJSON[key];	
						}
					} catch (err1) {
					  console.error('Unable to add CLV data', err1);
					}
				}
				try {
					if(sfAccount) {
						var sfAccountObj = JSON.parse(sfAccount);
						if (sfAccountObj.sfAccountId) {
							userEventObj['consumer-id'] = sfAccountObj.sfAccountId;
						}
						if (sfAccountObj.email) {
							userEventObj.em = btoa(sfAccountObj.email);
						}
					}
				} catch (err1) {
					console.error('Unable to add sfaccountID', err1);
				  }
				window.dataLayer.push({
					'event': 'loadUserData',
					'user': userEventObj
				});
			} else {
				if(sfAccount) {
					var sfAccountObj = JSON.parse(sfAccount);
					if (sfAccountObj.email) {
						userEventObj.em = btoa(sfAccountObj.email);
						window.dataLayer.push({
							'event': 'loadUserData',
							'user': userEventObj
						});
					}
				}
			}
		} catch (err) {
			console.error('Failed push to dataLayer',err);
		}
	});
});